import React from 'react';

import { ProductDetail } from 'components/product-detail';
import { ProductWizardProvider } from 'state/product-wizard';
import { ProductMenuObject } from 'state/product-wizard/types';

export interface IMenuWizardProps {
  product: ProductMenuObject;
}

export const ProductWizard = React.memo<IMenuWizardProps>(({ product }) => {
  return (
    <ProductWizardProvider product={product}>
      <ProductDetail />
    </ProductWizardProvider>
  );
});
